<template>
  <div>
    <div class="recording-btn" :class="{ 'full-view': screenShareOn }" v-if="displayButton == 'SHOW-REC'" @click="changeStatusOfBtn()">
      <button>
        <div class="circle"></div>
        <span class="pt-3 pl-4">Rec</span>
      </button>
    </div>
    <div class="recording-btn" :class="{ 'full-view': screenShareOn }" v-else-if="displayButton == 'SHOW-PENDING'">
      <div class="pending-text">
        <div class="circle"></div>
        <span class="pt-3 pl-4">Pending</span>
      </div>
    </div>
    <div class="recording-btn" :class="{ 'full-view': screenShareOn }" v-else-if="displayButton == 'SHOW-TIMER'" @click="endTHRecordingConfirmation">
      <div class="text-format">
        <div class="square"></div>
        {{ archiveTimerString }}
      </div>
    </div>
    <div class="recording-btn" :class="{ 'full-view': screenShareOn }" v-else-if="displayButton == 'RECORDING-NOT-ALLOWED'">
      <div class="text-format not-allowed"><i class="fa fa-times-circle" aria-hidden="true"></i>Recording not allowed</div>
    </div>
  </div>
</template>
<script>
import toastr from "toastr";
import swal from "sweetalert2";
import LocalStorageService from "../../services/localStorage";
import { AclRule } from "vue-acl";
import { mapGetters } from "vuex";
import _ from "lodash";

const SIGNAL_TYPE = "signal_type";
const MESSAGE_RECORDING_REQUESTED = "recording_requested";
const MESSAGE_RECORDING_ACCEPTED = "recording_accepted";
const MESSAGE_RECORDING_DENIED = "recording_denied";
const MESSAGE_RECORDING_STARTED = "recording_start";
const MESSAGE_RECORDING_STOP_REQUESTED = "recording_stop_requested";
const MESSAGE_RECORDING_STOPPED = "recording_stopped";
const MESSAGE_RECORDING_TIMEOUT = "recording_timeout";
const REC_BUTTON = "SHOW-REC";
const PENDING_BUTTON = "SHOW-PENDING";
const TIMER_BUTTON = "SHOW-TIMER";
const RECORDING_NOT_ALLOWED = "RECORDING-NOT-ALLOWED";

export default {
  name: "TeleHealthRecording",
  props: {
    session: {
      type: Object,
      required: true
    },
    stream: {
      type: Array,
      required: true
    },
    sessionDetails: {
      type: Object,
      required: true
    },
    recordingOptions: {
      type: Object,
      required: true
    },
    screenShareOn: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data: () => {
    return {
      archiveTimerString: "00:00",
      archiveDurationInSec: 0,
      archiveDetail: null,
      displayButton: "INACTIVE",
      jwtToken: null,
      archiveTimer: null,
      endRecordingPopupVisible: false,
      recordingData: {
        appointmentId: LocalStorageService.getItem("currentCallId"),
        archiveDuration: 0,
        cancelledBy: null,
        startTime: 0,
        endTime: 0,
        isRecordingPermisionGranted: false,
        recordingPermissionRequestedBy: "Participant",
        recordingPermissionRequestedTime: 0,
        recordingPermissionRespondedTime: 0
      },
      isSubcriberJoined: false,
      isConsentBtnClicked: false,
      multipleRecordingStatus: false,
      callIsAlreadyStoped: false
    };
  },
  computed: {
    ...mapGetters(["token", "user"]),
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    }
  },
  watch: {
    recordingOptions: {
      deep: true,
      immediate: true,
      handler(value) {
        const recordingOptions = value;
        if (recordingOptions.isRecordingTrue) {
          this.displayButton = REC_BUTTON;
        } else {
          this.displayButton = RECORDING_NOT_ALLOWED;
        }
      }
    },
    isSubcriberJoined: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val) {
          this.consentManager();
        }
      }
    },
    isConsentBtnClicked: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val) {
          this.consentManager();
        }
      }
    }
  },
  mounted() {
    this.siteId = this.user.siteIds ? this.user.siteIds[0] : null;
    this.$root.$on("videoCallEnded", data => {
      const self = this;
      // to by pass the ending of video call without saving any data.
      if (this.archiveDetail && this.archiveDetail.id == null) {
        return;
      }
      // To store archive details when recording is on-going, but call got ended.
      if (this.displayButton == TIMER_BUTTON) {
        this.recordingData.cancelledBy = data && data.participantEndTheCall ? "Participant" : "PI";
        setTimeout(() => {
          self.sendArchiveDataFact(true, true); // post API
        }, 5);
      }
    });
    this.$root.$on("subcriberJoined", () => {
      this.isSubcriberJoined = true;
    });
  },
  methods: {
    changeStatusOfBtn() {
      let recordingInProgress = false;
      this.$api.getRecordingDetailsFact(this.recordingData.appointmentId, this.sessionDetails.participantId).then(
        response => {
          const recordingDetails = response.body;
          if (recordingDetails.length !== 0) {
            recordingDetails.forEach(record => {
              if (record && record.hasOwnProperty("endTime") && !record.endTime) {
                recordingInProgress = true;
                return;
              }
            });
            if (recordingInProgress) {
              toastr.error("This session is already being recorded.");
            } else if (recordingDetails[0].createdBy !== this.user.id) {
              this.$api.getResearchTeamMembersFact(this.$route.params.studyId, this.siteId).then(
                response => {
                  const teamMembers = _.filter(response.body, member => member.id !== this.user.id);
                  const recordingMember = _.filter(teamMembers, member => member.id === recordingDetails[0].createdBy);
                  toastr.error("This session recording is in control of " + recordingMember[0].firstName + " " + recordingMember[0].lastName + ".");
                },
                error => {
                  this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting research team members.");
                }
              );
            } else {
              this.isConsentBtnClicked = true;
              this.displayButton = PENDING_BUTTON;
              if (!this.isSubcriberJoined) {
                toastr.success("A recording request will be sent when the participant joins the call.");
              } else if (this.multipleRecordingStatus) {
                this.consentManager();
              }
            }
          } else {
            this.isConsentBtnClicked = true;
            this.displayButton = PENDING_BUTTON;
            if (!this.isSubcriberJoined) {
              toastr.success("A recording request will be sent when the participant joins the call.");
            } else if (this.multipleRecordingStatus) {
              this.consentManager();
            }
          }
        },
        error => {
          toastr.error(error.body && error.body.message ? error.body.message : "Error while getting recording details.");
        }
      );
    },
    consentManager() {
      if (!this.multipleRecordingStatus) {
        if (!this.isSubcriberJoined || !this.isConsentBtnClicked) {
          return;
        }
      }
      let fiveMinuteTimer = null;
      this.recordingData.recordingPermissionRequestedTime = new Date().getTime();
      const processRequest = () => {
        this.listenSignals(SIGNAL_TYPE, MESSAGE_RECORDING_ACCEPTED, this.recordingRequestAccepted, fiveMinuteTimer);
        this.listenSignals(SIGNAL_TYPE, MESSAGE_RECORDING_DENIED, this.recordingRequestDenied, fiveMinuteTimer);
      };
      toastr.success("Recording request sent");
      fiveMinuteTimer = setTimeout(() => {
        this.recordingRequestTimeout();
      }, 5 * 60 * 1000);
      this.sendSignal(SIGNAL_TYPE, MESSAGE_RECORDING_REQUESTED, processRequest);
    },
    sendSignal(type, data, callback) {
      const self = this;
      this.session.signal({ data: data, type: type }, function(error) {
        if (error) {
          toastr.error(error.name ? error.name + " : " + error.message : "Error while sending consent");
        } else {
          if (!self.multipleRecordingStatus) {
            callback();
          }
        }
      });
    },
    listenSignals(type, msgType, callback, extraDataOption) {
      this.session.on("signal:" + type, function(event) {
        if (event.data == msgType) {
          callback(extraDataOption);
        }
      });
    },
    recordingRequestAccepted(fiveMinuteTimer) {
      clearTimeout(fiveMinuteTimer);
      this.multipleRecordingStatus = true;
      this.startRecordingUsingOpenTokAPI();
      this.recordingData.isRecordingPermisionGranted = true;
      this.recordingData.recordingPermissionRespondedTime = new Date().getTime();
    },
    recordingRequestDenied(fiveMinuteTimer) {
      clearTimeout(fiveMinuteTimer);
      this.multipleRecordingStatus = true;
      this.recordingData.isRecordingPermisionGranted = false;
      this.recordingData.isRecordingPermisionGranted = false;
      this.displayButton = REC_BUTTON;
      this.sendArchiveDataFact(true, false, MESSAGE_RECORDING_DENIED); // Post API
      toastr.error("Recording request denied");
    },
    recordingRequestTimeout() {
      this.displayButton = REC_BUTTON;
      this.multipleRecordingStatus = true;
      this.sendSignal(SIGNAL_TYPE, MESSAGE_RECORDING_TIMEOUT, () => {});
    },
    stopRecording() {
      this.recordingData.cancelledBy = "PI";
      if (!this.callIsAlreadyStoped) {
        this.stopRecordingUsingOpenTokAPI();
      }
      toastr.success("Recording ended");
    },
    startRecordingUsingOpenTokAPI() {
      this.multipleRecordingStatus = true;
      this.callIsAlreadyStoped = false;
      const data = {
        sessionId: this.sessionDetails.sessionId,
        hasAudio: true,
        hasVideo: true,
        type: "CUSTOM",
        stylesheet: `stream {
          float: left;
        }
        stream:first-child:nth-last-child(1) {
          width: 100%;
          height: 100%;
        }

        stream:first-child:nth-last-child(2),
        stream:first-child:nth-last-child(2) ~ stream {
          width: 50%;
          height: 100%;
        }
        stream:first-child:nth-last-child(3),
        stream:first-child:nth-last-child(3) ~ stream,
        stream:first-child:nth-last-child(4),
        stream:first-child:nth-last-child(4) ~ stream {
          width: 50%;
          height: 50%;
        }
        stream:first-child:nth-last-child(5),
        stream:first-child:nth-last-child(5) ~ stream,
        stream:first-child:nth-last-child(6),
        stream:first-child:nth-last-child(6) ~ stream,
        stream:first-child:nth-last-child(7),
        stream:first-child:nth-last-child(7) ~ stream,
        stream:first-child:nth-last-child(8),
        stream:first-child:nth-last-child(8) ~ stream,
        stream:first-child:nth-last-child(9),
        stream:first-child:nth-last-child(9) ~ stream
        {
          width: 33.33%;
          height: 33.33%;
        }`,
        name: "archive_name",
        outputMode: "COMPOSED",
        resolution: "1280x720"
      };
      this.$api.startTHcallRecording(data).then(response => {
        toastr.success("Recording started");
        this.recordingData.startTime = new Date().getTime();
        this.sendSignal(SIGNAL_TYPE, MESSAGE_RECORDING_STARTED, () => {});
        this.listenSignals(
          SIGNAL_TYPE,
          MESSAGE_RECORDING_STOP_REQUESTED,
          () => {
            this.recordingData.cancelledBy = "Participant";
            this.stopRecording();
          },
          null
        );
        this.displayButton = TIMER_BUTTON;
        this.manageArchiveTimer(true);
        this.archiveDetail = response.body;
        this.sendArchiveDataFact(false); // POST API
      });
    },
    stopRecordingUsingOpenTokAPI() {
      this.callIsAlreadyStoped = true;
      this.$api.stopTHcallRecording(this.archiveDetail.id).then(() => {
        this.displayButton = REC_BUTTON;
        this.recordingData.endTime = new Date().getTime();
        this.manageArchiveTimer(false);
        this.sendSignal(SIGNAL_TYPE, MESSAGE_RECORDING_STOPPED, () => {});
        this.sendArchiveDataFact(true); // PUT API
        this.archiveDurationInSec = 0;
      });
    },
    sendArchiveDataFact(stopReocrding, callEnded = false, signalMsg) {
      if (this.archiveDetail == null && signalMsg != MESSAGE_RECORDING_DENIED) {
        return;
      }
      const data = {
        telehealthSessionId: this.sessionDetails.sessionId,
        appointmentId: this.recordingData.appointmentId,
        participantId: this.sessionDetails.participantId,
        archiveDuration: this.archiveDurationInSec == 0 ? null : this.archiveDurationInSec,
        archiveId: this.archiveDetail && this.archiveDetail.id ? this.archiveDetail.id : null,
        archiveName: "archive_name",
        cancelledBy: this.recordingData.cancelledBy != null ? (this.recordingData.cancelledBy == "PI" ? this.user.id : this.sessionDetails.participantId) : null,
        createdBy: this.user.id,
        startTime: this.recordingData.startTime == 0 ? null : this.recordingData.startTime,
        endTime: this.recordingData.endTime == 0 ? null : this.recordingData.endTime,
        isRecordingPermisionGranted: this.recordingData.isRecordingPermisionGranted,
        recordingPermissionRequestedTime: this.recordingData.recordingPermissionRequestedTime == 0 ? null : this.recordingData.recordingPermissionRequestedTime,
        recordingPermissionRespondedTime: this.recordingData.recordingPermissionRespondedTime == 0 ? null : this.recordingData.recordingPermissionRespondedTime,
        isCaptured: true
      };
      this.$api.sendArchiveDetails(data).then(() => {
        if (stopReocrding) {
          this.archiveDetail = null;
          this.recordingData = {
            appointmentId: this.recordingData.appointmentId,
            archiveDuration: 0,
            cancelledBy: null,
            startTime: 0,
            endTime: 0,
            isRecordingPermisionGranted: false,
            recordingPermissionRequestedBy: "Participant",
            recordingPermissionRequestedTime: 0,
            recordingPermissionRespondedTime: 0
          };
        }
        if (callEnded) {
          localStorage.removeItem("thread-currentCallId");
          localStorage.removeItem("thread-inProgressCallId");
        }
      });
    },
    manageArchiveTimer(start) {
      const prefix = v => {
        return v < 10 ? "0" + v : v;
      };
      const reset = (n, v) => {
        let index = n;
        index++;
        return index === v ? 0 : index;
      };
      let hh = 0;
      let mm = 0;
      let s = 0;
      if (start) {
        this.archiveTimer = setInterval(() => {
          if (s == 59) {
            mm = reset(mm, 60);
          }
          if (mm == 59) {
            hh = reset(hh, 24);
            mm = reset(mm, 60);
          }
          this.archiveTimerString = (hh ? prefix(hh) + ":" : "") + prefix(mm) + ":" + prefix((s = reset(s, 60)));
          this.archiveDurationInSec++;
        }, 1000);
      } else {
        clearInterval(this.archiveTimer);
        this.archiveTimerString = "00:00";
      }
    },
    endTHRecordingConfirmation() {
      swal({
        title: "You are about to stop this recording. Would you like to continue?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#007bff",
        cancelButtonColor: "#007bff",
        confirmButtonText: "Cancel",
        cancelButtonText: "Yes"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          this.stopRecording();
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.recording-btn {
  height: 50px;
  width: 100px;
  position: absolute;
  top: 10px;
  left: 10px;
  border-radius: 4px;
  z-index: 999;
  &.full-view {
    position: fixed;
  }
  button {
    border: none;
    border-radius: 3px;
    cursor: pointer;
  }
  button:focus {
    outline: none;
  }
}
.recording-btn .circle {
  background: #979797;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  margin: 0 4px 0 0;
  display: inline-block;
  vertical-align: middle;
}
.recording-btn .square {
  background: #f16559;
  width: 16px;
  height: 16px;
  position: relative;
  top: 0.21rem;
  margin-right: 9px;
  cursor: pointer;
}
.recording-btn .text-format {
  background: #fff;
  color: #f16559;
  padding: 3px 9px 5px;
  font-family: RobotoRegular;
  font-size: 14px;
  font-weight: bold;
  display: inline-flex;
  cursor: pointer;
  border-radius: 3px;
  &.not-allowed {
    color: #000;
    font-size: 12px;
    border-radius: 2px;
    margin-top: 6px;
    margin-left: 5px;
    width: 155px !important;
    .fa-times-circle {
      color: #979797;
      margin-right: 6px;
      margin-top: 4px;
    }
  }
}
.recording-btn button,
.pending-text {
  background: #fff;
  color: #000;
  padding: 3px 9px 5px;
  font-family: RobotoRegular;
  font-size: 14px;
  font-weight: bold;
  border-radius: 3px;
}
</style>
